<template>
  <app-layout>
    <template #header>
      <div class="flex items-center">
        <div class="flex-1">
          <h1 class="text-lg">
            {{ state.company.name | sentencecase }}
          </h1>
        </div>
        <div class="ml-6 self-center">
          <a 
            :href="route('companies.index')"
            class="transition-all transition-normal inline-flex items-center px-4 py-3 border-2 border-grey-300 text-grey-800 shadow text-sm font-semibold bg-white hover:bg-gray-50 focus:outline-none focus:shadow-outline no-underline hover:bg-primary-100 hover:border-primary-300 leading-none"
          >
            All Companies
          </a>
        </div>
      </div>
    </template>
    <template #navigation>
      <app-header>
        <template #navigation>
          <ul>
            <li
              v-for="(tab, index) in availableTabs"
              :key="index"
            >
              <a
                href="#"
                :class="{
                  'is-active': activeTab === tab.component
                }"
                @click.prevent="switchTab(tab.component)"
              >
                {{ tab.name }}
              </a>
            </li>
          </ul>
        </template>
      </app-header>
    </template>
    <keep-alive>
      <component
        :is="`Company${activeTab}`"
        :state="state"
      />
    </keep-alive>
  </app-layout>
</template>

<script>
export default {
  name: "CompaniesView",
  data() {
    return {
      activeTab: "Profile",
      tabs: []
    };
  },
  computed: {
    company() {
      return this.state.company;
    },
    availableTabs() {
      return this.tabs.filter(tab => tab.visible);
    }
  },
  created() {
    document.title = `${this.company.name} Profile :: ${document.title}`;
    this.tabs = [
      {
        name: "Profile",
        component: "Profile",
        visible: true
      },
      {
        name: "Users",
        component: "Users",
        visible: this.isVisible(this.company.users),
      },
      {
        name: "Applications",
        component: "Applications",
        visible: this.isVisible(this.company.applications)
      },
      {
        name: "Projects",
        component: "Projects",
        visible: this.isVisible(this.company.projects)
      }
    ];
  },
  methods: {
    isVisible(obj) {
      return obj !== undefined && obj !== null;
    },
    switchTab(component) {
      this.activeTab = component;
    }
  }
};
</script>
